import React, { FC, ReactNode } from "react";
import { EventType, StayDataType } from "data/types";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import EventShopCard from "components/EventShopCard/EventShopCard";
import { useGetEventsQuery } from "store/api";

export interface SectionGridFeaturePropertyProps {
  stayListings?: StayDataType[];
  gridClass?: string;
  heading?: ReactNode;
  subHeading?: ReactNode;
  headingIsCenter?: boolean;
  tabs?: string[];
}

const SectionEventsShop: FC<SectionGridFeaturePropertyProps> = ({
  gridClass = "",
  heading = "Te recomendamos",
  subHeading = "",
  headingIsCenter,
  tabs = ["New York", "Tokyo", "Paris", "London"],
}) => {

  const {data}= useGetEventsQuery({});
  const eventsData = data?.eventDB;
  const events:EventType[] = eventsData?.map((item:any) => {
    return {
      _id: item.event._id,
      nameEvent: item.event.nameEvent,
      date:item.event.date ,
      category:item.event.category ,
      city: {
        _id:item.event.city._id ,
        description:item.event.city.description ,
        province:item.event.city.province ,
      },
      acronym:item.event.acronym ,
      description:item.event.description ,
      payments: [],
      sponsors: [],
      existRequirements: item.event.existRequirements,
      requirementsDescription:item.event.requirementsDescription ,
      place:item.event.place ,
      available:item.event.available ,
      publicType:item.event.publicType ,
      startTime:item.event.startTime ,
      endTime:item.event.endTime ,
      isFree: item.event.isFree,
      isDelete: item.event.isDelete,
      img:item.event.img ,
      lat:item.event.lat ,
      lng:item.event.lng ,
      secretLocation: item.event.secretLocation,
      iva: item.event.iva,
      hasCapacity: item.event.hasCapacity,
      maximunTickets: item.event.maximunTickets,
      valueIva: item.event.valueIva,
      imgHeader:item.event.imgHeader ,
      haveSubscribers: item.event.haveSubscribers,
      haveDistribution: item.event.haveDistribution,
      type:item.event.type ,
      publicationDate:item.event.publicationDate ,
      publicationTime:item.event.publicationTime ,
      specialDiscounts: item.event.specialDiscounts,
      percentageSpecialDiscounts: item.event.percentageSpecialDiscounts,
      imgDistributionPlace:item.event.imgDistributionPlace,
      localitiesFrom:item.localitiesFrom,
      salesman:item.salesman,
    };
  }
  );

  const renderCard = (stay: EventType, index: number) => {
    return <EventShopCard key={index} className="h-full" data={stay} />;
  };

  return (
    <div className="nc-SectionGridFeatureProperty relative">
      <div
        className={`grid gap-6 md:gap-8 grid-cols-1 sm:grid-cols-1 xl:grid-cols-2 ${gridClass}`}
      >
        {events?.map((item, index) => (
          <div key={index} className="w-full">{renderCard(item, index)}</div>
        ))}
      </div>
      <div className="flex mt-16 justify-center items-center">
        <ButtonPrimary>Ver más</ButtonPrimary>
      </div>
    </div>
  );
};

export default SectionEventsShop;
